import React, { useState } from 'react';

const SearchTwitter = () => {

  const [reversedIcon, setReversedIcon] = useState(false);

  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="24"
         viewBox="0 0 24 24"
         onMouseEnter={() => setReversedIcon(true)}
         onMouseLeave={() => setReversedIcon(false)}
         fill="none">
      <path
        d="M7.54752 21.7505C16.6042 21.7505 21.5578 14.2472 21.5578 7.74028C21.5578 7.52716 21.5578 7.315 21.5434 7.1038C22.507 6.40675 23.3389 5.54368 24 4.555C23.1014 4.9534 22.148 5.21455 21.1718 5.32972C22.1998 4.71441 22.9692 3.7465 23.3366 2.6062C22.3701 3.1798 21.3126 3.58402 20.2099 3.8014C19.4675 3.01197 18.4856 2.48924 17.4162 2.31408C16.3468 2.13892 15.2494 2.32111 14.294 2.83245C13.3385 3.34379 12.5782 4.15577 12.1307 5.14274C11.6833 6.12972 11.5735 7.23666 11.8186 8.29228C9.8609 8.19407 7.94576 7.68531 6.19745 6.799C4.44915 5.91269 2.90676 4.66866 1.6704 3.14764C1.04073 4.23163 0.847872 5.51486 1.1311 6.73606C1.41433 7.95725 2.15234 9.02459 3.19488 9.72076C2.41123 9.69779 1.64465 9.48639 0.96 9.10444V9.16684C0.960311 10.3037 1.35385 11.4054 2.07387 12.2852C2.79389 13.165 3.79606 13.7686 4.9104 13.9937C4.18548 14.1915 3.42487 14.2204 2.68704 14.0782C3.00181 15.0565 3.61443 15.912 4.43924 16.5251C5.26405 17.1382 6.25983 17.4783 7.28736 17.4977C6.26644 18.3002 5.09731 18.8935 3.84687 19.2437C2.59643 19.5939 1.28921 19.6942 0 19.5387C2.25183 20.9837 4.87192 21.7502 7.54752 21.7467"
        fill={reversedIcon ? '#225aea' : '#1DA1F2'} />
    </svg>
  );
};

export default SearchTwitter;
